import { useState, useEffect } from 'react';
import { Spin, Space, Tag, Timeline, Typography } from 'antd';
import { APIClient } from '../helpers/api_helper';
import useIntentFieldResolver from './useIntentFieldResolver';

const { Text } = Typography;
const api = new APIClient();

const historyTypeLabel = {
  '+': { color: 'green', text: 'Ustvarjeno' },
  '~': { color: 'blue', text: 'Spremenjeno' },
  '-': { color: 'red', text: 'Izbrisano' },
};

const HistoryTimeline = ({ model, objectId }) => {
  const { resolveFieldValue } = useIntentFieldResolver();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!model || !objectId) return;
    setLoading(true);
    api.get('/api/history/', { model, object_id: objectId })
      .then(resp => setHistory(resp))
      .catch(err => console.error('History fetch error:', err))
      .finally(() => setLoading(false));
  }, [model, objectId]);

  return (
    <Spin spinning={loading}>
      <Timeline
        style={{ marginTop: 16 }}
        items={history.map(record => {
          const label = historyTypeLabel[record.history_type] ?? { color: 'grey', text: record.history_type };
          return {
            color: label.color,
            children: (
              <div>
                <Space>
                  <Text strong>{new Date(record.history_date).toLocaleString('sl-SI')}</Text>
                  <Tag color={label.color}>{label.text}</Tag>
                  <Text type="secondary">{record.history_user ?? record.history_change_reason ?? '—'}</Text>
                </Space>
                {record.changes && record.changes.length > 0 && (
                  <ul style={{ marginTop: 4, paddingLeft: 16 }}>
                    {record.changes.map((c, i) => (
                      <li key={i}>
                        <Text code>{c.field}</Text>: <Text delete>{resolveFieldValue(c.field, c.old)}</Text> → <Text>{resolveFieldValue(c.field, c.new)}</Text>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ),
          };
        })}
      />
    </Spin>
  );
};

export default HistoryTimeline;
